import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { DCO_CAMPAIGN_CREATIVE_REPORT_ID } from './dcoCampaignCreativeReportId';

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.SPENT.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.CLICKS.field,
        FIELDS.VCTR.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.CVR.field,
        FIELDS.CPA.field,
        FIELDS.VCPM.field,
    ].map(field => generateColumnId(DCO_CAMPAIGN_CREATIVE_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [
        FIELDS.IS_ACTIVE.field,
        FIELDS.STATUS.field,
        FIELDS.TEMPLATE_NAME.field,
        FIELDS.THUMBNAIL_URL.field,
        FIELDS.URL.field,
        FIELDS.TEMPLATE_ID.field,
        FIELDS.CAMPAIGN_NAME.field,
        FIELDS.ACTIONS_COLUMN.field,
    ].map(field => generateColumnId(DCO_CAMPAIGN_CREATIVE_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.STATUS.field,
    FIELDS.TEMPLATE_NAME.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.THUMBNAIL_URL_COMFORTABLE.field,
    FIELDS.TITLE.field,
    FIELDS.URL.field,
    FIELDS.TEMPLATE_ID.field,
    FIELDS.CAMPAIGN_NAME.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.VCTR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.CVR.field,
    FIELDS.CPA.field,
    FIELDS.VCPM.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(DCO_CAMPAIGN_CREATIVE_REPORT_ID, field));

const performanceColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.TEMPLATE_NAME.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.THUMBNAIL_URL_COMFORTABLE.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.VCTR.field,
    FIELDS.CLICKS.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.VCPM.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(DCO_CAMPAIGN_CREATIVE_REPORT_ID, field));

const setupColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.STATUS.field,
    FIELDS.TEMPLATE_NAME.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.THUMBNAIL_URL_COMFORTABLE.field,
    FIELDS.URL.field,
    FIELDS.TEMPLATE_ID.field,
    FIELDS.CAMPAIGN_NAME.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(DCO_CAMPAIGN_CREATIVE_REPORT_ID, field));

export { customColumns, defaultColumns, performanceColumns, setupColumns };
